import React from 'react'

const SearchResult = () => {
    const data = [
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
        {
          "title": "lorem ipsum",
          "href": "http://opensource.place"
        },
    ]
    
    return (
        <div className="search-result">
        <ul className="results">
        {
          data && data.map((d, id) => (
            <li key= {id}><a href={d.href}>{d.title}</a></li>
            ))
        }
        </ul>
    </div>
    )
}

export default SearchResult
